import { GGSCountryController } from './../../../../language/countryMapper/GGSCountryController';

/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 29.08.13, 10:04
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { EnvGlobalsHandler } from "../../../EnvGlobalsHandler";
import { AbstractJavascriptFunctionCallFactory } from "../../../controller/externalInterface/vo/AbstractJavascriptFunctionCallFactory";
import { AbstractJavascriptFunctionCallVO } from "../../../controller/externalInterface/vo/AbstractJavascriptFunctionCallVO";
import { BasicModel } from "../../BasicModel";
import { JavascriptCallSetSessionParametersVO } from "./JavascriptCallSetSessionParametersVO";

export class JavascriptCallOnSetSessionParametersFactory implements AbstractJavascriptFunctionCallFactory {
    constructor(private _playerID: number = -1) {
        //this constructor is needed because of Empire there the BasicModel is not used so we have no general way to get the static variable
    }

    public createVO(): AbstractJavascriptFunctionCallVO {
        let vo: JavascriptCallSetSessionParametersVO = new JavascriptCallSetSessionParametersVO(EnvGlobalsHandler.globals.gameId,
            EnvGlobalsHandler.globals.networkId,
            BasicModel.instanceProxy.selectedInstanceVO.instanceId,
            (this._playerID == -1) ? BasicModel.userData.playerID : this._playerID,
            EnvGlobalsHandler.globals.accountId,
            GGSCountryController.instance.currentCountry.ggsLanguageCode,
            GGSCountryController.instance.currentCountry.ggsCountryCode,
            EnvGlobalsHandler.globals.pln,
            EnvGlobalsHandler.globals.displayName,
            EnvGlobalsHandler.globals.versionInformation.buildNumberGame,
            EnvGlobalsHandler.globals.versionInformation.buildNumberServer
        );
        return vo;
    }
}

